module.exports = __webpack_public_path__ + "static/media/niw.30223ea8.jpg";